import * as yup from 'yup';
import { Row, RenderConfig, Column, TextInput, SelectInput, EMPTY_ARRAY, NumberInput, BOOLEAN_OPTIONS } from 'commons-ui';
import { onChangeDashboardAction, onChangeOfferValueAction } from './helper';

export const validationSchemaCreate = yup.object().shape({
	segmentName: yup.string().required('Segment Name is a required field'),
	bucketName: yup.string().required('Bucket Name is a required field'),
	cashbackRewardLimit: yup.string().required('Cashback Limit is a required field'),
	bonusRewardLimit: yup.string().required('Bonus Limit is a required field'),
	transactionAllowPerDay: yup.number().required('Applicable transaction count is a required field'),
	offer: yup
		.array()
		.of(
			yup.object().shape({
				startRange: yup.string().required('start range is required field'),
				endRange: yup.string(),
				rewardPercentage: yup.object().shape({
					totalPercentage: yup.number(),
					cashbackPercentage: yup.number(),
					bonusPercentage: yup.number()
				}),
				rewardFlatValue: yup.object().shape({
					totalFlatValue: yup.string(),
					cashbackFlatValue: yup.string(),
					bonusFlatValue: yup.string()
				})
			})
		)
		.required()
});

export const validationSchemaEdit = yup.object().shape({
	segmentName: yup.string().required('Segment Name is a required field'),
	bucketName: yup.string().required('Bucket Name is a required field'),
	cashbackRewardLimit: yup.string().required('Cashback Limit is a required field'),
	bonusRewardLimit: yup.string().required('Bonus Limit is a required field'),
	transactionAllowPerDay: yup.number().required('Applicable transaction count is a required field'),
	offer: yup
		.array()
		.of(
			yup.object().shape({
				startRange: yup.string().required('start range is required field'),
				endRange: yup.string(),
				rewardPercentage: yup.object().shape({
					totalPercentage: yup.number(),
					cashbackPercentage: yup.number(),
					bonusPercentage: yup.number()
				}),
				rewardFlatValue: yup.object().shape({
					totalFlatValue: yup.string(),
					cashbackFlatValue: yup.string(),
					bonusFlatValue: yup.string()
				})
			})
		)
		.required()
});

export const FORM_FIELD_KEYS = {
	SEGMENT_NAME: 'segmentName',
	MAP_VALUE: 'mapValue',
	EXP_NAME: 'expName',
	BUCKET_NAME: 'bucketName',
	OFFER_NAME: 'offerName',
	IS_ACTIVE: 'isActive',
	CASHBACK_REWARD_LIMIT: 'cashbackRewardLimit',
	BONUS_REWARD_LIMIT: 'bonusRewardLimit',
	TRANSACTION_ALLOW_PER_DAY: 'transactionAllowPerDay',
	START_RANGE: 'startRange',
	END_RANGE: 'endRange',
	TOTAL_PERCENTAGE: 'totalPercentage',
	TOTAL_FLAT_VALUE: 'totalFlatValue',
	CASHBACK_PERCENTAGE: 'cashbackPercentage',
	BONUS_PERCENTAGE: 'bonusPercentage',
	CASHBACK_FLAT_VALUE: 'cashbackFlatValue',
	BONUS_FLAT_VALUE: 'bonusFlatValue',
	OFFER: 'offer',
	RANK: 'rank',
	FORM: 'form'
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.OFFER_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.SEGMENT_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.EXP_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.BUCKET_NAME)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.RANK)]),
		new Column([new Row(FORM_FIELD_KEYS.IS_ACTIVE)]),
		new Column([new Row(FORM_FIELD_KEYS.CASHBACK_REWARD_LIMIT)]),
		new Column([new Row(FORM_FIELD_KEYS.BONUS_REWARD_LIMIT)])
	]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.TRANSACTION_ALLOW_PER_DAY)])]),
	new Row(FORM_FIELD_KEYS.OFFER, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.START_RANGE)]),
		new Column([new Row(FORM_FIELD_KEYS.END_RANGE)]),
		new Column([new Row(FORM_FIELD_KEYS.TOTAL_PERCENTAGE)]),
		new Column([new Row(FORM_FIELD_KEYS.CASHBACK_PERCENTAGE)]),
		new Column([new Row(FORM_FIELD_KEYS.BONUS_PERCENTAGE)]),
		new Column([new Row(FORM_FIELD_KEYS.TOTAL_FLAT_VALUE)]),
		new Column([new Row(FORM_FIELD_KEYS.CASHBACK_FLAT_VALUE)]),
		new Column([new Row(FORM_FIELD_KEYS.BONUS_FLAT_VALUE)])
	]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.MAP_VALUE)])])
];

export const EDIT_CTD_FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.OFFER_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.SEGMENT_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.EXP_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.BUCKET_NAME)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.IS_ACTIVE)]),
		new Column([new Row(FORM_FIELD_KEYS.CASHBACK_REWARD_LIMIT)]),
		new Column([new Row(FORM_FIELD_KEYS.BONUS_REWARD_LIMIT)])
	]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.TRANSACTION_ALLOW_PER_DAY)])]),
	new Row(FORM_FIELD_KEYS.OFFER, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.START_RANGE)]),
		new Column([new Row(FORM_FIELD_KEYS.END_RANGE)]),
		new Column([new Row(FORM_FIELD_KEYS.TOTAL_PERCENTAGE)]),
		new Column([new Row(FORM_FIELD_KEYS.CASHBACK_PERCENTAGE)]),
		new Column([new Row(FORM_FIELD_KEYS.BONUS_PERCENTAGE)]),
		new Column([new Row(FORM_FIELD_KEYS.TOTAL_FLAT_VALUE)]),
		new Column([new Row(FORM_FIELD_KEYS.CASHBACK_FLAT_VALUE)]),
		new Column([new Row(FORM_FIELD_KEYS.BONUS_FLAT_VALUE)])
	])
];

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.SEGMENT_NAME]: new RenderConfig()
		.setName('segmentName')
		.setLabel('Segment Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: [{ id: '1', label: 'TEST' }],
			required: true,
			onChangeCallback: onChangeDashboardAction
		})
		.setToolTip('CTD Segment Name'),
	[FORM_FIELD_KEYS.MAP_VALUE]: new RenderConfig()
		.setName('mapValue')
		.setLabel('')
		.setRenderer(TextInput)
		.setIsCollapsible(true)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			hidden: true,
			required: true
		})
		.setToolTip('CTD Segment Name'),

	[FORM_FIELD_KEYS.OFFER_NAME]: new RenderConfig()
		.setName('offerName')
		.setLabel('Offer name')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: false })
		.setToolTip('CTD Bucket Name'),
	[FORM_FIELD_KEYS.EXP_NAME]: new RenderConfig()
		.setName('expName')
		.setLabel('Experiment Name')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: false, edit: false }, required: true })
		.setToolTip('CTD Bucket Name'),
	[FORM_FIELD_KEYS.BUCKET_NAME]: new RenderConfig()
		.setName('bucketName')
		.setId('bucketName')
		.setLabel('Bucket Name')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true,
			onChangeCallback: onChangeDashboardAction
		})
		.setToolTip('CTD Bucket Name'),
	[FORM_FIELD_KEYS.IS_ACTIVE]: new RenderConfig()
		.setName('isActive')
		.setLabel('Is Offer Active')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			options: BOOLEAN_OPTIONS,
			required: true
		})
		.setToolTip('Is offer active or not'),
	[FORM_FIELD_KEYS.CASHBACK_REWARD_LIMIT]: new RenderConfig()
		.setName('cashbackRewardLimit')
		.setLabel('Cashback Limit(₹)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			onChangeCallback: onChangeOfferValueAction
		}),
	[FORM_FIELD_KEYS.BONUS_REWARD_LIMIT]: new RenderConfig()
		.setName('bonusRewardLimit')
		.setLabel('Bonus Limit(₹)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			onChangeCallback: onChangeOfferValueAction
		}),
	[FORM_FIELD_KEYS.TRANSACTION_ALLOW_PER_DAY]: new RenderConfig()
		.setName('transactionAllowPerDay')
		.setLabel('Applicable transaction count')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.OFFER]: new RenderConfig()
		.setName('offer')
		.setLabel('Offer Details')
		.setRenderProps({
			isArrayField: true,
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.START_RANGE]: new RenderConfig()
		.setName('startRange')
		.setLabel('Winnning Wallet amount start range(₹)(Incl.)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			onChangeCallback: onChangeOfferValueAction
		}),
	[FORM_FIELD_KEYS.END_RANGE]: new RenderConfig()
		.setName('endRange')
		.setLabel('Winnning Wallet amount end range(₹)(Excl.)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			onChangeCallback: onChangeOfferValueAction
		}),
	[FORM_FIELD_KEYS.TOTAL_PERCENTAGE]: new RenderConfig()
		.setName('totalPercentage')
		.setLabel('Conversion Total Percentage(%)')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: false
		}),
	[FORM_FIELD_KEYS.CASHBACK_PERCENTAGE]: new RenderConfig()
		.setName('cashbackPercentage')
		.setLabel('Conversion Cashback Percentage(%)')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: false
		}),
	[FORM_FIELD_KEYS.BONUS_PERCENTAGE]: new RenderConfig()
		.setName('bonusPercentage')
		.setLabel('Conversion Bonus Percentage(%)')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: false
		}),
	[FORM_FIELD_KEYS.TOTAL_FLAT_VALUE]: new RenderConfig()
		.setName('totalFlatValue')
		.setLabel('Conversion Total Flat Value(₹)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: false,
			onChangeCallback: onChangeOfferValueAction
		}),
	[FORM_FIELD_KEYS.CASHBACK_FLAT_VALUE]: new RenderConfig()
		.setName('cashbackFlatValue')
		.setLabel('Conversion Cashback Flat Value(₹)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: false,
			onChangeCallback: onChangeOfferValueAction
		}),
	[FORM_FIELD_KEYS.BONUS_FLAT_VALUE]: new RenderConfig()
		.setName('bonusFlatValue')
		.setLabel('Conversion Bonus Flat Value(₹)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: false,
			onChangeCallback: onChangeOfferValueAction
		}),
	[FORM_FIELD_KEYS.RANK]: new RenderConfig()
		.setName('rank')
		.setId('rankNumber')
		.setLabel('Offer Rank')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			required: true
		})
};

export const CTD_OFFER_UPDATE_CONFIG = {
	...FORM_FIELD_CONFIG,
	[FORM_FIELD_KEYS.FORM]: new RenderConfig()
		.setName('form')
		.setLabel('Offer form')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			required: true
		})
};

export const getFormDefaults = (segmentList: any, mapValues: any) => {
	return {
		segmentName: segmentList,
		mapValue: JSON.stringify(mapValues),
		expName: 'abc',
		bucketName: 'control',
		cashbackRewardLimit: '100',
		bonusRewardLimit: '100',
		isActive: true,
		transactionAllowPerDay: 1,
		rank: 1,
		offer: [
			{
				startRange: '0',
				rewardPercentage: { totalPercentage: 0, cashbackPercentage: 0, bonusPercentage: 0 },
				rewardFlatValue: { totalFlatValue: '0', cashbackFlatValue: '0', bonusFlatValue: '0' }
			}
		]
	};
};
